
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompleteEmissionSource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmissionSourceType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ghgSavingPotentialId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceOfEmission"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineUnitName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionUnitName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineConceptName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineGhgFactor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineConsumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineAssumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baselineEvidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customBaselineConcept"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionReducesConsumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionReducesGhgFactor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionConceptName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionGhgFactor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionConsumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionAssumption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solutionEvidence"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customSolutionConcept"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specificReductionPerUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metricAssignments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompleteMetricAssignment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":598}};
    doc.loc.source = {"body":"#import \"./CompleteMetricAssignment.gql\"\n\nfragment CompleteEmissionSource on EmissionSourceType {\n  id\n  ghgSavingPotentialId\n  sourceOfEmission\n  unitName\n  baselineUnitName\n  solutionUnitName\n\n  baselineConceptName\n  baselineGhgFactor\n  baselineConsumption\n  baselineAssumption\n  baselineEvidence\n  customBaselineConcept\n\n  solutionReducesConsumption\n  solutionReducesGhgFactor\n\n  solutionConceptName\n  solutionGhgFactor\n  solutionConsumption\n  solutionAssumption\n  solutionEvidence\n  customSolutionConcept\n\n  specificReductionPerUnit\n\n  metricAssignments {\n    ...CompleteMetricAssignment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./CompleteMetricAssignment.gql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CompleteEmissionSource"] = oneQuery(doc, "CompleteEmissionSource");
        
